import { defineComponent as Y, ref as I, toRef as a, computed as p, provide as Z, watch as ee, h as z, mergeProps as oe } from "vue";
import te, { popoverBaseProps as L } from "./ghl-ui.es216.js";
import ne from "./ghl-ui.es995.js";
import re from "./ghl-ui.es996.js";
import { dropdownInjectionKey as ie } from "./ghl-ui.es997.js";
import de from "./ghl-ui.es712.js";
import { createTreeMate as le } from "./ghl-ui.es871.js";
import ae from "./ghl-ui.es706.js";
import se from "./ghl-ui.es716.js";
import ce from "./ghl-ui.es854.js";
import B from "./ghl-ui.es855.js";
import { call as N } from "./ghl-ui.es876.js";
import { createKey as h } from "./ghl-ui.es384.js";
import { useThemeClass as ue } from "./ghl-ui.es857.js";
import { keep as fe } from "./ghl-ui.es930.js";
import pe from "./ghl-ui.es998.js";
import { createRefSetter as he } from "./ghl-ui.es999.js";
const ve = {
  animated: {
    type: Boolean,
    default: !0
  },
  keyboard: {
    type: Boolean,
    default: !0
  },
  size: {
    type: String,
    default: "medium"
  },
  inverted: Boolean,
  placement: {
    type: String,
    default: "bottom"
  },
  onSelect: [Function, Array],
  options: {
    type: Array,
    default: () => []
  },
  menuProps: Function,
  showArrow: Boolean,
  renderLabel: Function,
  renderIcon: Function,
  renderOption: Function,
  nodeProps: Function,
  labelField: {
    type: String,
    default: "label"
  },
  keyField: {
    type: String,
    default: "key"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  // for menu, not documented
  value: [String, Number]
}, me = Object.keys(L), ge = Object.assign(Object.assign(Object.assign({}, L), ve), B.props), Le = Y({
  name: "Dropdown",
  inheritAttrs: !1,
  props: ge,
  setup(t) {
    const w = I(!1), c = de(a(t, "show"), w), d = p(() => {
      const {
        keyField: e,
        childrenField: i
      } = t;
      return le(t.options, {
        getKey(n) {
          return n[e];
        },
        getDisabled(n) {
          return n.disabled === !0;
        },
        getIgnored(n) {
          return n.type === "divider" || n.type === "render";
        },
        getChildren(n) {
          return n[i];
        }
      });
    }), u = p(() => d.value.treeNodes), v = I(null), m = I(null), y = I(null), f = p(() => {
      var e, i, n;
      return (n = (i = (e = v.value) !== null && e !== void 0 ? e : m.value) !== null && i !== void 0 ? i : y.value) !== null && n !== void 0 ? n : null;
    }), b = p(() => d.value.getPath(f.value).keyPath), x = p(() => d.value.getPath(t.value).keyPath), K = ae(() => t.keyboard && c.value);
    se({
      keydown: {
        ArrowUp: {
          prevent: !0,
          handler: W
        },
        ArrowRight: {
          prevent: !0,
          handler: U
        },
        ArrowDown: {
          prevent: !0,
          handler: _
        },
        ArrowLeft: {
          prevent: !0,
          handler: H
        },
        Enter: {
          prevent: !0,
          handler: j
        },
        Escape: D
      }
    }, K);
    const {
      mergedClsPrefixRef: P,
      inlineThemeDisabled: C
    } = ce(t), A = B("Dropdown", "-dropdown", re, pe, t, P);
    Z(ie, {
      labelFieldRef: a(t, "labelField"),
      childrenFieldRef: a(t, "childrenField"),
      renderLabelRef: a(t, "renderLabel"),
      renderIconRef: a(t, "renderIcon"),
      hoverKeyRef: v,
      keyboardKeyRef: m,
      lastToggledSubmenuKeyRef: y,
      pendingKeyPathRef: b,
      activeKeyPathRef: x,
      animatedRef: a(t, "animated"),
      mergedShowRef: c,
      nodePropsRef: a(t, "nodeProps"),
      renderOptionRef: a(t, "renderOption"),
      menuPropsRef: a(t, "menuProps"),
      doSelect: k,
      doUpdateShow: S
    }), ee(c, (e) => {
      !t.animated && !e && T();
    });
    function k(e, i) {
      const {
        onSelect: n
      } = t;
      n && N(n, e, i);
    }
    function S(e) {
      const {
        "onUpdate:show": i,
        onUpdateShow: n
      } = t;
      i && N(i, e), n && N(n, e), w.value = e;
    }
    function T() {
      v.value = null, m.value = null, y.value = null;
    }
    function D() {
      S(!1);
    }
    function H() {
      R("left");
    }
    function U() {
      R("right");
    }
    function W() {
      R("up");
    }
    function _() {
      R("down");
    }
    function j() {
      const e = F();
      e != null && e.isLeaf && c.value && (k(e.key, e.rawNode), S(!1));
    }
    function F() {
      var e;
      const {
        value: i
      } = d, {
        value: n
      } = f;
      return !i || n === null ? null : (e = i.getNode(n)) !== null && e !== void 0 ? e : null;
    }
    function R(e) {
      const {
        value: i
      } = f, {
        value: {
          getFirstAvailableNode: n
        }
      } = d;
      let o = null;
      if (i === null) {
        const l = n();
        l !== null && (o = l.key);
      } else {
        const l = F();
        if (l) {
          let s;
          switch (e) {
            case "down":
              s = l.getNext();
              break;
            case "up":
              s = l.getPrev();
              break;
            case "right":
              s = l.getChild();
              break;
            case "left":
              s = l.getParent();
              break;
          }
          s && (o = s.key);
        }
      }
      o !== null && (v.value = null, m.value = o);
    }
    const O = p(() => {
      const {
        size: e,
        inverted: i
      } = t, {
        common: {
          cubicBezierEaseInOut: n
        },
        self: o
      } = A.value, {
        padding: l,
        dividerColor: s,
        borderRadius: E,
        optionOpacityDisabled: $,
        [h("optionIconSuffixWidth", e)]: M,
        [h("optionSuffixWidth", e)]: V,
        [h("optionIconPrefixWidth", e)]: q,
        [h("optionPrefixWidth", e)]: G,
        [h("fontSize", e)]: J,
        [h("optionHeight", e)]: Q,
        [h("optionIconSize", e)]: X
      } = o, r = {
        "--n-bezier": n,
        "--n-font-size": J,
        "--n-padding": l,
        "--n-border-radius": E,
        "--n-option-height": Q,
        "--n-option-prefix-width": G,
        "--n-option-icon-prefix-width": q,
        "--n-option-suffix-width": V,
        "--n-option-icon-suffix-width": M,
        "--n-option-icon-size": X,
        "--n-divider-color": s,
        "--n-option-opacity-disabled": $
      };
      return i ? (r["--n-color"] = o.colorInverted, r["--n-option-color-hover"] = o.optionColorHoverInverted, r["--n-option-color-active"] = o.optionColorActiveInverted, r["--n-option-text-color"] = o.optionTextColorInverted, r["--n-option-text-color-hover"] = o.optionTextColorHoverInverted, r["--n-option-text-color-active"] = o.optionTextColorActiveInverted, r["--n-option-text-color-child-active"] = o.optionTextColorChildActiveInverted, r["--n-prefix-color"] = o.prefixColorInverted, r["--n-suffix-color"] = o.suffixColorInverted, r["--n-group-header-text-color"] = o.groupHeaderTextColorInverted) : (r["--n-color"] = o.color, r["--n-option-color-hover"] = o.optionColorHover, r["--n-option-color-active"] = o.optionColorActive, r["--n-option-text-color"] = o.optionTextColor, r["--n-option-text-color-hover"] = o.optionTextColorHover, r["--n-option-text-color-active"] = o.optionTextColorActive, r["--n-option-text-color-child-active"] = o.optionTextColorChildActive, r["--n-prefix-color"] = o.prefixColor, r["--n-suffix-color"] = o.suffixColor, r["--n-group-header-text-color"] = o.groupHeaderTextColor), r;
    }), g = C ? ue("dropdown", p(() => `${t.size[0]}${t.inverted ? "i" : ""}`), O, t) : void 0;
    return {
      mergedClsPrefix: P,
      mergedTheme: A,
      // data
      tmNodes: u,
      // show
      mergedShow: c,
      // methods
      handleAfterLeave: () => {
        t.animated && T();
      },
      doUpdateShow: S,
      cssVars: C ? void 0 : O,
      themeClass: g == null ? void 0 : g.themeClass,
      onRender: g == null ? void 0 : g.onRender
    };
  },
  render() {
    const t = (d, u, v, m, y) => {
      var f;
      const {
        mergedClsPrefix: b,
        menuProps: x
      } = this;
      (f = this.onRender) === null || f === void 0 || f.call(this);
      const K = (x == null ? void 0 : x(void 0, this.tmNodes.map((C) => C.rawNode))) || {}, P = {
        ref: he(u),
        class: [d, `${b}-dropdown`, this.themeClass],
        clsPrefix: b,
        tmNodes: this.tmNodes,
        style: [...v, this.cssVars],
        showArrow: this.showArrow,
        arrowStyle: this.arrowStyle,
        scrollable: this.scrollable,
        onMouseenter: m,
        onMouseleave: y
      };
      return z(ne, oe(this.$attrs, P, K));
    }, {
      mergedTheme: w
    } = this, c = {
      show: this.mergedShow,
      theme: w.peers.Popover,
      themeOverrides: w.peerOverrides.Popover,
      internalOnAfterLeave: this.handleAfterLeave,
      internalRenderBody: t,
      onUpdateShow: this.doUpdateShow,
      "onUpdate:show": void 0
    };
    return z(te, Object.assign({}, fe(this.$props, me), c), {
      trigger: () => {
        var d, u;
        return (u = (d = this.$slots).default) === null || u === void 0 ? void 0 : u.call(d);
      }
    });
  }
});
export {
  Le as default,
  ge as dropdownProps
};
